import { SupportChannelConfig } from "./supportChannels";

// The placeholders docker/entrypoint.sh substitutes. An unset variable leaves
// the placeholder in the served HTML, so a deployment that has not configured
// support reads back the literal token -- which must count as ABSENT, not as
// a URL. Without this the portal would offer a link to "VARSUPPORTZOHOURL".
const PLACEHOLDERS = ["VARSUPPORTZOHOURL", "VARSUPPORTWHATSAPP"];

const configured = (value: string | undefined): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();
  return trimmed === "" || PLACEHOLDERS.includes(trimmed) ? undefined : trimmed;
};

export const getSupportChannelConfig = (env: {
  REACT_APP_SUPPORT_ZOHO_URL?: string;
  REACT_APP_SUPPORT_WHATSAPP?: string;
}): SupportChannelConfig => ({
  zohoUrl: configured(env.REACT_APP_SUPPORT_ZOHO_URL),
  whatsappNumber: configured(env.REACT_APP_SUPPORT_WHATSAPP),
});

export default getSupportChannelConfig;
